import React from 'react'
import { Link } from 'react-router-dom';
import {} from 'react-bootstrap';
import {Button,Container ,Col,Row} from 'react-bootstrap'
import Particle from '../Particle';
import vid from '../../Assets/logo.png'
import success from '../../Assets/success.png'
function RequestSubmite() {
  return (
    <div>
     <Container fluid className=" " id="about" style={{ paddingTop:'100px' }}>
     <Particle/>
     <Container>
    
      </Container>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col>
       <div className="success">
       <h4 className="black "  >
        We Have Sent Email To: User@gmail.com
        </h4>
       </div>
      </Col>
        
     
      </Row>
    </Container>

    </div>

  )
}

export default RequestSubmite
